import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProfileState {
    // Overview
    name: string;
    surname: string;
    title: string;
    age: number;
    weight: number;
    height: number;

    // Personal Information
    email: string;
    gender: string;
    dateOfBirth: string;

    // Contact Information
    address: string;
    city: string;
    province: string;
    phone: string;

    // Heart Rate
    fcMax: number;
    fcRiposo: number;
    fcSoglia: number;

    // Notes
    restDay: string;
    notes: string;
}

const initialState: ProfileState = {
    // Overview
    name: '',
    surname: '',
    title: '',
    age: 0,
    weight: 0,
    height: 0,

    // Personal Information
    email: '',
    gender: '',
    dateOfBirth: '',

    // Contact Information
    address: '',
    city: '',
    province: '',
    phone: '',

    // Heart Rate
    fcMax: 195,
    fcRiposo: 48,
    fcSoglia: 172,

    // Notes
    restDay: '',
    notes: '',
};

const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        updateProfile: (state, action: PayloadAction<Partial<ProfileState>>) => {
            return { ...state, ...action.payload };
        },
        updateField: (state, action: PayloadAction<{ field: keyof ProfileState; value: any }>) => {
            const { field, value } = action.payload;
            (state as any)[field] = value;
        },
    },
});

export const { updateProfile, updateField } = profileSlice.actions;

export default profileSlice.reducer;
